import { createSlice } from "@reduxjs/toolkit";
import {
  createVisitorThunk,
  fetchVisitorsThunk,
  updateVisitorThunk,
  deleteVisitorThunk,
} from "./visitor.action";

const initialState = {
  visitors: [],
  loading: false,
  error: null,
  isModalOpen: false,
  slectedVisitor: {},
  currentPage: 1,
  count: {
    preRegisteredVisitors: 0,
    directVisitors: 0,
    currentlyInside: 0,
    visitorsToday: 0,
  },
  totalPages: 1,
  totalVisitors: 0,
};

const visitorSlice = createSlice({
  name: "visitor",
  initialState,
  reducers: {
    setModalOpen: (state, action) => {
      state.isModalOpen = true;
      state.slectedVisitor = action.payload;
    },
    setModalClose: (state) => {
      state.isModalOpen = false;
      state.slectedVisitor = {};
    },
  },
  extraReducers: (builder) => {
    // --- CREATE ---
    builder
      .addCase(createVisitorThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createVisitorThunk.fulfilled, (state, action) => {
        state.loading = false;
        // The new visitor object is assumed to be in action.payload.visitor or action.payload.data
        const newVisitor = action.payload?.visitor || action.payload?.data;
        if (newVisitor) {
          state.visitors.push(newVisitor);
        }
      })
      .addCase(createVisitorThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to add visitor";
      });

    // --- FETCH ALL ---
    builder
      .addCase(fetchVisitorsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVisitorsThunk.fulfilled, (state, action) => {
        state.loading = false;
        // The list of visitors is assumed to be in action.payload.visitors or action.payload.data
        state.visitors =
          action.payload?.visitors || action.payload?.data?.visitors || [];
        state.currentPage = action.payload?.currentPage || 1;
        state.totalPages = action.payload?.totalPages || 1;
        state.totalVisitors = action.payload?.totalVisitors || 0;
        state.count = {
          preRegisteredVisitors: action.payload?.PreRegisteredVisitors || 0,
          directVisitors: action.payload?.DirectVisitors || 0,
          currentlyInside: action.payload?.CurrentlyInside || 0,
          visitorsToday: action.payload?.VisitorsToday || 0,
        };
        state.loading = false;
      })
      .addCase(fetchVisitorsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch visitors";
      });

    // --- UPDATE ---
    builder
      .addCase(updateVisitorThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateVisitorThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateVisitorThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to update visitor";
      });
  },
});

export const { setModalOpen, setModalClose } = visitorSlice.actions;

export default visitorSlice.reducer;
